import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ServerErrorStatus } from '../enums/server-error-status.enum';
import { AppError } from '../interfaces/app-error.interface';
import { LoginErrorDetails } from '../interfaces/login-error-details.interface';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	private errorSubject = new BehaviorSubject<AppError | null>(null);
	error$ = this.errorSubject.asObservable();

	/**
	 * Set when the current user cannot be loaded (401/403/5xx). The app shows a
	 * full-page error instead of the regular shell, since it can't run without a user.
	 */
	serverError = signal<ServerErrorStatus | null>(null);
	loginErrorDetails = signal<LoginErrorDetails | null>(null);

	setError(data: AppError) {
		this.errorSubject.next(data);
	}

	clearError() {
		this.errorSubject.next(null);
	}

	setServerError(status: ServerErrorStatus, loginErrorDetails: LoginErrorDetails | null = null) {
		this.serverError.set(status);
		this.loginErrorDetails.set(loginErrorDetails);
	}
}
